import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { USERS } from "@/constants/testIds";
import { ContactFields } from "@/components/ContactFields";

const EMPTY = { username: "", name: "", password: "", role: "cs", email: "", wa_phone: "" };

export const UserDialog = ({ open, onOpenChange, user, onSaved }) => {
  const [form, setForm] = useState(EMPTY);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  useEffect(() => {
    if (open) setForm(user ? { ...EMPTY, username: user.username, name: user.name, role: user.role, email: user.email || "", wa_phone: user.wa_phone || "" } : EMPTY);
  }, [open, user]);

  const submit = async (e) => {
    e.preventDefault();
    const contact = { email: form.email.trim(), wa_phone: form.wa_phone.trim() };
    try {
      const role = user?.role === "superadmin" ? null : form.role;
      if (user) await api.put(`/users/${user.id}`, { name: form.name, role, password: form.password || null, ...contact });
      else await api.post("/users", { username: form.username, name: form.name, password: form.password, role: form.role, ...contact });
      toast.success(user ? "Pengguna diperbarui" : "Akun dibuat");
      onOpenChange(false);
      onSaved();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md max-h-[90vh] overflow-y-auto">
        <DialogHeader><DialogTitle className="font-heading tracking-tight">{user ? "Edit Pengguna" : "Tambah Akun"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label>Username</Label>
            <Input value={form.username} onChange={set("username")} disabled={!!user} required minLength={3} data-testid={USERS.formUsername} />
          </div>
          <div className="space-y-2">
            <Label>Nama lengkap</Label>
            <Input value={form.name} onChange={set("name")} required data-testid={USERS.formName} />
          </div>
          <div className="space-y-2">
            <Label>{user ? "Password baru (kosongkan jika tidak diubah)" : "Password"}</Label>
            <Input type="password" value={form.password} onChange={set("password")} required={!user} minLength={6} data-testid={USERS.formPassword} />
          </div>
          {user?.role !== "superadmin" && (
          <div className="space-y-2">
            <Label>Peran</Label>
            <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
              <SelectTrigger data-testid={USERS.formRole}><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="cs">Customer Service (baca & salin)</SelectItem>
                <SelectItem value="admin">Admin (kelola semua)</SelectItem>
              </SelectContent>
            </Select>
          </div>
          )}
          <ContactFields form={form} set={set} />
          <DialogFooter>
            <Button type="button" variant="outline" className="rounded-full" onClick={() => onOpenChange(false)}>Batal</Button>
            <Button type="submit" className="rounded-full bg-brand hover:bg-brand-dark text-white" data-testid={USERS.formSubmit}>Simpan</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
